import ReactMarkdown from 'react-markdown';
import type { ParagraphBlock as ParagraphBlockType } from '../types';

// ─────────────────────────────────────────────
// ParagraphBlock — 正文段落，支持 Markdown
// ─────────────────────────────────────────────
export function ParagraphBlock({ block }: { block: ParagraphBlockType }) {
  if (!block.text) return null;
  return (
    <div className="text-[14px] text-[#404040] leading-[1.8] [&_strong]:font-semibold [&_strong]:text-[#09090B]">
      <ReactMarkdown disallowedElements={['script', 'iframe', 'object', 'embed']}>{block.text}</ReactMarkdown>
    </div>
  );
}
